<template>
<div class='d-flex flex-row justify-content-center align-items-center'>
  <div v-for='page in numberOfPages' :key='page' 
          class='location-marker rounded-circle' 
          :class="{ 'bg-primary': page === pageShowing, 'bg-gray-400': page !== pageShowing}"></div>
</div>
</template>
<script>
export default {
  name: 'PageProgressIndicator',
  props: {
    numberOfPages: {
      type: Number,
      required: true
    },
    pageShowing: {
      type: Number,
      required: false
    }
  }
}
</script>
<style scoped lang='scss'>
.location-marker {
  height: 1.0em;
  width: 1.0em;
  margin-left: 0.5em;
  margin-right: 0.5em;
}
</style>